var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Warning Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8035669,15.9107092 L12.8035669,17.5178514 L11.1964247,17.5178514 L11.1964247,15.9107092 L12.8035669,15.9107092 Z M12.8035669,9.48214016 L12.8035669,14.3035669 L11.1964247,14.3035669 L11.1964247,9.48214016 L12.8035669,9.48214016 Z M11.9994615,4.28571381 C11.9377797,4.28571381 11.7846898,4.30206321 11.6910523,4.45886883 L2.82596126,19.2142032 C2.73232378,19.3687793 2.79028984,19.5077492 2.81927287,19.5605132 C2.85048536,19.6155067 2.94189338,19.7433292 3.13362726,19.7433292 L20.8660389,19.7433292 C21.0570296,19.7433292 21.1499239,19.6147635 21.1803933,19.5605132 C21.2101195,19.5077492 21.2680855,19.3687793 21.174448,19.2142032 L12.3086138,4.45886883 C12.2149763,4.30206321 12.0618865,4.28571381 11.9994615,4.28571381 M21.5868102,21.5357071 L2.41279951,21.5357071 C1.80369259,21.5357071 1.26208565,21.2166894 0.964764332,20.6831181 C0.669050157,20.1551719 0.679496581,19.52919 0.991282179,19.0108866 L10.5762786,3.05517827 C10.8800285,2.5505356 11.4127962,2.25 11.9994031,2.25 C12.5868136,2.25 13.1195812,2.5505356 13.4225275,3.05517827 L23.0091311,19.0108866 C23.3201131,19.52919 23.3313631,20.1543683 23.035649,20.6823146 C22.7383276,21.2166894 22.1959171,21.5357071 21.5868102,21.5357071",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-generic",
    transform: "translate(-257.000000, -674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(209.000000, -597.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(0.000000, 680.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2",
    transform: "translate(24.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-/-Atoms-/-Icons-/-Clear",
    transform: "translate(24.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    fill: "#C1381B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.750000, 0.750000)",
    id: "\\uD83C\\uDFA8-Icon-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C1381B",
    x: 0,
    y: 0,
    width: 22.5,
    height: 22.5
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8b040f3c2cf384c47792efcce4022d89.svg";
export { ForwardRef as ReactComponent };